import { render, staticRenderFns } from "./LostStats.vue?vue&type=template&id=240a9442"
import script from "./LostStats.vue?vue&type=script&lang=js"
export * from "./LostStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports